/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    roleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    organizationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    organizationName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RoleDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoleDto
     */
    modifiedAt?: Date;
}

/**
 * Check if a given object implements the RoleDto interface.
 */
export function instanceOfRoleDto(value: object): value is RoleDto {
    return true;
}

export function RoleDtoFromJSON(json: any): RoleDto {
    return RoleDtoFromJSONTyped(json, false);
}

export function RoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
    };
}

export function RoleDtoToJSON(json: any): RoleDto {
    return RoleDtoToJSONTyped(json, false);
}

export function RoleDtoToJSONTyped(value?: RoleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'roleName': value['roleName'],
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'modifiedAt': value['modifiedAt'] == null ? value['modifiedAt'] : value['modifiedAt'].toISOString(),
    };
}

